import { authRoles } from 'app/auth';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import React from 'react';

const AdminRouteConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.admin,
  routes: [
    {
      path: routesUrl.administration,
      exact: true,
      component: React.lazy(() => import('./pages/AdminMerchantDashboardPage')),
    },
    {
      path: routesUrl.franchisePanel,
      exact: true,
      component: React.lazy(() => import('./pages/FranchisePanelPage')),
    },
    {
      path: routesUrl.adminHome,
      exact: true,
      auth: authRoles.homeAdmin,
      component: React.lazy(() => import('app/main/apps/home/pages/AdminHomePage')),
    },
  ],
};

export default AdminRouteConfig;
